import { MultiSelectDropdown } from '../Dropdowns/MultiSelectDropdown';
import {
  MultiSelectCustomAttribute,
  SelectCustomAttribute,
} from '../../sdk/types/common/customAttribute';
import { mapCustomAttributeOptions } from './helpers';

export type MultiSelectAttributeInputProps = {
  attribute: SelectCustomAttribute | MultiSelectCustomAttribute;
  values: string[];
  onChange: (vals: string[]) => void;
  disabled?: boolean;
  placeholder?: string;
  clearable?: boolean;
  isOpen?: boolean;
  onClose?: () => void;
  error?: boolean;
  ['data-testid']?: string;
};

/**
 * Layer A primitive: multi-select dropdown for multi_select-typed custom
 * attributes. Like `SelectAttributeInput` it exposes `isOpen`/`onClose`
 * pass-through props for consumers that need to drive open state externally.
 *
 * Accepts both `SelectCustomAttribute` and `MultiSelectCustomAttribute` for
 * symmetry with `SelectAttributeInput` — both share the same enum-value shape.
 */
export const MultiSelectAttributeInput = ({
  attribute,
  values,
  onChange,
  disabled,
  placeholder,
  clearable = true,
  isOpen,
  onClose,
  error,
  'data-testid': dataTestId,
}: MultiSelectAttributeInputProps) => {
  const options = mapCustomAttributeOptions(attribute);
  const selectedItems = options.filter((o) => values.includes(o.value));

  return (
    <MultiSelectDropdown
      options={options}
      selectedItems={selectedItems}
      onChange={(items) => onChange(items.map((i) => i.value))}
      disabled={disabled}
      placeholder={placeholder}
      clearable={clearable}
      isOpen={isOpen}
      onClose={onClose}
      error={error}
      data-testid={dataTestId ?? `custom-attr-${attribute.id}`}
    />
  );
};
